import React from 'react'
import '../styles/article.css'

const Chapter9 = () => {
    return (
        <div className='history-page'>
            <h1 className='history-chapter-lbl'>Chapter 9</h1>
            <h1 className='history-heading'>The 1980s – Choreography, Staging, and Costuming
                in Show Choir</h1>


            <div className='paragraphwimage-large'>

                <div className='imagewborder'>
                    <img src='images/history/14.jpg' alt='show Choir' />
                </div>

                <p>Inspired by the success of
                    the Bishop Luers contest,
                    show choir competitions
                    began springing up across
                    the United States,
                    particularly in Indiana,
                    Illinois, and Wisconsin. Many
                    high school choral directors
                    saw show choir as an
                    opportunity to attract students to their traditional choral
                    programs, often making concert choir membership a
                    prerequisite for joining the show group. However, few directors
                    had experience with choreography and staging, so they often
                    had to rely on trial and error to bring these performances to
                    life.</p>
            </div>




            <h2 className='sub-head'>Television and Pop Culture: A New Source of Inspiration</h2>
            <p>The 1980s brought a wave of television programs that
                sparked ideas and provided hope for the show choir
                movement. Educators across the country tuned in weekly,
                looking for inspiration from popular shows. Among the most
                influential were:</p>
            <p> Solid Gold (1980-1988): A Top 40 countdown show featuring
                the Solid Gold Dancers, whose choreographed routines
                brought popular music to life.
                The Tracey Ullman Show (1987-1989): Known for its weekly
                production numbers choreographed by Paula Abdul, this show
                introduced innovative, stylized dance moves that soon
                influenced show choir performances.
                Black Entertainment Television (BET) (1980-present): A
                24-hour music channel that showcased urban dance styles
                like hip hop, funk/groove, and street dance, which would later
                make their way into show choir choreography.</p>

            <p> The most significant influence, however, was MTV (Music
                Television), which launched in 1981. MTV introduced
                audiences to fast-paced, visually engaging choreography
                through music videos. Michael Jackson’s iconic “Thriller” video
                set a new standard for production and choreography, while his
                hits “Beat It” and “Bad,” along with Janet Jackson’s “Rhythm
                Nation,” showcased polished, synchronized routines that
                became instant cultural touchstones. MTV’s impact on show
                choir choreography trends would last well into the next two
                decades.</p>

            <h2 className='sub-head'>The Demand for Choreography and Staging Expertise</h2>
            <p> As show choir grew, so did the demand for guidance on
                staging and choreography. Several experts rose to meet this
                need. John Jacobson, a choreographer and author for Hal
                Leonard Publications, published books, videos, and written
                notes on staging techniques. Sally Albrecht, a choreographer,
                author, and composer with Alfred Publishing, also contributed
                with booklets and instructional guides. Both traveled to
                conventions and reading sessions across the country, helping
                educators incorporate movement and staging into their choirs.</p>
            <p> One of the most influential figures of the time was Dwight
                Jordan, who began his career as a high school band director
                in Mt. Zion, Illinois, in 1978. He took up choreography as a
                challenge, quickly becoming a prolific figure in the show choir
                world. Jordan co-founded Showchoir Camps of America, the
                leading summer program for show choir staging and
                techniques. Known for his dynamic style, Jordan developed a
                distinctive method that balanced vocal clarity with expressive
                movement. When lyrics were key, he used simple steps like
                step-touches or sways. But when instrumental breaks allowed,
                he introduced spins, jumps, and arm extensions, creating a
                powerful visual impact without compromising vocal
                performance.</p>

            <h2 className='sub-head'>Production Techniques and Innovations</h2>
            <p>Choreography and staging were what distinguished show
                choirs from traditional choral groups. In the 1980s, show choir
                productions began incorporating large-scale elements
                commonly seen in theme parks, such as elaborate costume
                changes, special effects (including fog and CO blasts), and
                creative backdrops. With around 40 singers, dancers, tech
                crew members, and instrumentalists packed into a
                40-by-40-foot stage, directors and choreographers needed
                ingenuity and careful planning to make each performance
                visually exciting.</p>
            <p>The traditional three-step choral risers proved insufficient for
                these high-energy routines. Responding to the growing
                demand, the Wenger Corporation, a manufacturer of staging
                platforms, introduced the Encore Staging System in 1980.
                This innovative setup included triangular platforms of various
                heights, allowing directors to create interesting geometric
                shapes on stage. The system also offered optional sound and
                lighting packages, which enhanced the production value of
                show choir performances.</p>
            <p>However, the Encore System faced challenges with durability
                as the demands of show choir grew. By 1988, Wenger
                released the more adaptable and lightweight Versalite
                platforms, which quickly became popular among show choirs
                for their flexibility and resilience.</p>

            <h2 className='sub-head'>Show Choir as a Cultural and Economic Force</h2>
            <p>The expanding interest in show choir influenced multiple
                industries. Costume and apparel companies began producing
                catalogs specifically for show choir, offering colorful, sequined
                costumes designed for theatrical impact. Travel companies
                capitalized on the popularity of competitions, organizing
                events in destination cities like Orlando and Honolulu.
                Photographers and videographers began vying for contracts
                to capture the excitement of competitions, while music
                publishers saw increased demand for pop and show choir
                arrangements.</p>
            <p>As the competition scene grew, show choir directors
                increasingly took on the role of producers, overseeing every
                aspect of the performance. Directors hired choreographers,
                arrangers, costume designers, and even travel coordinators.
                This shift toward a full production approach made show choir
                an expensive venture, often requiring substantial financial
                support from booster programs and fundraising efforts.</p>

            <h2 className='sub-head'>The Lasting Impact of the 1980s on Show Choir</h2>
            <p>
                The 1980s laid the foundation for what show choir would
                become in the following decades. Fueled by popular culture,
                television, and new staging innovations, show choir
                transformed from a casual after-school activity into a full-scale
                performance art. Directors and students embraced the
                influence of MTV and Broadway, pushing boundaries and
                redefining what choral music could be. Competitions became
                high-stakes events, with groups competing to deliver the most
                polished, energetic, and visually captivating shows.</p>
            <p>the end of the 1980s, show choir was an established and
                respected part of music education. It had evolved into a
                vibrant, dynamic art form that merged vocal performance with
                intricate choreography, captivating costumes, and compelling
                staging. This period of growth and innovation not only
                expanded the reach of show choir but also left a lasting legacy
                that would inspire future generations to continue exploring the
                possibilities of this unique American tradition.</p>








        </div>
    )
}

export default Chapter9